<template>
  <div class="nd-container container-fluid">
    <Sidebar v-if="isUserAuthenticated" />
    <SidebarToggle />
    <MainPanel :isUserAuthenticated="isUserAuthenticated" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import MainPanel from '@/components/MainPanel.vue';
import Sidebar from '@/components/Sidebar.vue';
import SidebarToggle from '@/components/SidebarToggle.vue';
import User from '~/auth/User';

export default defineComponent({
  components: {
    SidebarToggle,
    Sidebar,
    MainPanel
  },
  computed: {
    isUserAuthenticated(): boolean {
      return User.isAuthenticated();
    },
  },
});
</script>
